module.exports = __webpack_public_path__ + "img/search-active.ae533f1a.svg";